import React from "react";
import BankOfGeorgia from "../icons/bankOfGeorgia";
import TbcBank from "../icons/tbcBank";

export const KEEPZ_CODE = "Keepz";
export const IDENTOMAT_CODE = "Identomat";

export const ONBOARDING_TYPE = {
  onlyKeepz: 1,
};

export const BANK_CODES = {
  bog: "bog",
  tbc: "tbc",
};

export const ERROR_CODES = {
  redirect: "003",
  reset: "002",
};

export const BANKS = {
  [BANK_CODES.bog]: { translationKey: "bog", logo: <BankOfGeorgia /> },
  [BANK_CODES.tbc]: { translationKey: "tbc", logo: <TbcBank /> },
};
